import * as Data$dCodec$dJSON from "../Data.Codec.JSON/index.js";
import * as Data$dCodec$dJSON$dStrict from "../Data.Codec.JSON.Strict/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const Optional = x => x;
const rowListCodecStrictNilRowR = {rowListCodecStrict: v => Data$dCodec$dJSON$dStrict.record};
const rowListCodecNilRowRow = {rowListCodec: v => Data$dCodec$dJSON.record};
const rowListCodecStrict = dict => dict.rowListCodecStrict;
const rowListCodecStrictConsCod = dictRowListCodecStrict => () => () => dictIsSymbol => (
  {
    rowListCodecStrict: codecs => Data$dCodec$dJSON$dStrict.recordProp(dictIsSymbol)()(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(codecs))(dictRowListCodecStrict.rowListCodecStrict(codecs))
  }
);
const rowListCodecStrictConsOpt = dictRowListCodecStrict => () => () => dictIsSymbol => (
  {
    rowListCodecStrict: codecs => Data$dCodec$dJSON$dStrict.recordPropOptional(dictIsSymbol)()(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(codecs))(dictRowListCodecStrict.rowListCodecStrict(codecs))
  }
);
const rowListCodec = dict => dict.rowListCodec;
const rowListCodecConsCodec = dictRowListCodec => () => () => dictIsSymbol => (
  {
    rowListCodec: codecs => Data$dCodec$dJSON.recordProp(dictIsSymbol)()(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(codecs))(dictRowListCodec.rowListCodec(codecs))
  }
);
const rowListCodecConsOptional = dictRowListCodec => () => () => dictIsSymbol => (
  {
    rowListCodec: codecs => Data$dCodec$dJSON.recordPropOptional(dictIsSymbol)()(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(codecs))(dictRowListCodec.rowListCodec(codecs))
  }
);
const recordStrict = () => dictRowListCodecStrict => dictRowListCodecStrict.rowListCodecStrict;
const record = () => dictRowListCodec => dictRowListCodec.rowListCodec;
const optional = Optional;
const objectStrict = () => dictRowListCodecStrict => rec => Data$dCodec$dJSON$dStrict.objectStrict(dictRowListCodecStrict.rowListCodecStrict(rec));
const object = () => dictRowListCodec => rec => Data$dCodec$dJSON.object(dictRowListCodec.rowListCodec(rec));
export {
  Optional,
  object,
  objectStrict,
  optional,
  record,
  recordStrict,
  rowListCodec,
  rowListCodecConsCodec,
  rowListCodecConsOptional,
  rowListCodecNilRowRow,
  rowListCodecStrict,
  rowListCodecStrictConsCod,
  rowListCodecStrictConsOpt,
  rowListCodecStrictNilRowR
};
